import React from "react";
import { Dropdown } from "react-bootstrap";

type AllProps = {
  children: string;
  onClick: () => void;
  tooltipContent?: string;
  disabled?: boolean;
  hidden?: boolean;
}

// Description: Dropdown item component that is used in children of ToolbarWrapper component 
function ToolbarDropdownItemComponent(props: AllProps) {
  const { children, onClick, tooltipContent, disabled, hidden } = props;

  return (
    <Dropdown.Item disabled={disabled} hidden={hidden} onClick={onClick}
      data-tooltip-id="tb-tooltip" data-tooltip-content={tooltipContent} data-tooltip-place="right"
    >
      {children}
    </Dropdown.Item>
  );
}

export default React.memo(ToolbarDropdownItemComponent);
